import { useGetDirectorySettingsQuery } from 'store/api/version-api.slice';

import DirectorySettingsForm from './DirectorySettingsForm';

const ContainerDirectorySettingsForm = ({ handleChange }) => {
	const { data: directorySettingsResponse = {} } = useGetDirectorySettingsQuery();

	const directorySettings = directorySettingsResponse.results?.[0] || {};

	return <DirectorySettingsForm handleChange={handleChange} directorySettings={directorySettings} />;
};

export default ContainerDirectorySettingsForm;
